import React from 'react'

import './paragraph.scss'

import cn from '../../libs/class-names'

import {CommonProps, Overwrite} from '../../types'

import alertCircleIcon from '../../assets/icons/alert-circle.svg'

import Icon from '../icon'

type Props = Overwrite<
  CommonProps<'p'>,
  {
    children: React.ReactNode
    size?: 'default' | 'l' | 's' | 'xs'
    strong?: boolean
    minor?: boolean
    warning?: boolean
    error?: boolean
    errorIcon?: boolean
    success?: boolean
    contained?: boolean
    clamp?: number
  }
>

const Paragraph = ({
  className,
  children,
  size = 'default',
  strong = false,
  minor = false,
  warning = false,
  error = false,
  errorIcon = false,
  success = false,
  contained = false,
  clamp,
  ...props
}: Props) => (
  <p
    {...props}
    className={cn(
      'Paragraph',
      {
        [`size-${size}`]: true,
        strong,
        minor,
        warning,
        error,
        errorIcon,
        success,
        contained,
        clamp: !!clamp,
      },
      className
    )}
    style={{
      WebkitLineClamp: clamp,
    }}
  >
    {(warning || errorIcon) && <Icon source={alertCircleIcon} />}
    {children}
  </p>
)

export default Paragraph
